module.exports = __webpack_public_path__ + "static/media/butcher-3.ed732c30.png";